import { useEffect } from 'react';

import usePrevious from './usePrevious';

/**
 * USAGE
 *
 * before:
 *
 * useEffect(() => {
 *  setCounter(counter + 1)
 * }, [counter, setCounter])
 *
 * after:
 *
 * useEffectDebugger(() => {
 *  setCounter(counter + 1)
 * }, [counter, setCounter], ['counter', 'setCounter'])
 *
 *
 */

const useEffectDebugger = (
  effectHook: () => void,
  dependencies: any[],
  depNames: string[] = [],
) => {
  const previousDeps = usePrevious(dependencies, []);

  const changedDeps = dependencies.reduce((accum, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = depNames[index] || index;
      return {
        ...accum,
        [keyName]: {
          before: previousDeps[index],
          after: dependency,
        },
      };
    }

    return accum;
  }, {});

  if (Object.keys(changedDeps).length) {
    console.log('[use-effect-debugger] ', changedDeps);
  }

  useEffect(effectHook, dependencies);
};

export default useEffectDebugger;
